module.exports = __webpack_public_path__ + "static/media/IVe.4a5ffeb0.jpg";